import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { MoonIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative overflow-hidden bg-hero-glow pt-16 pb-10 sm:pt-20 sm:pb-14" data-id="element-216">
      <div className="mx-auto max-w-7xl px-6 lg:px-8" data-id="element-217">
        <div className="mx-auto max-w-2xl lg:max-w-none lg:flex lg:items-center lg:gap-x-16" data-id="element-218">
          <div className="lg:w-full lg:max-w-2xl lg:shrink-0" data-id="element-219">
            <FadeIn data-id="element-220">
              <div className="inline-flex items-center gap-2 rounded-full bg-gold/10 px-4 py-2 text-sm font-medium text-gold ring-1 ring-inset ring-gold/20 mb-8" data-id="element-221">
                <MoonIcon className="h-4 w-4" data-id="element-222" />
                <span data-id="element-223">Método 100% Natural</span>
              </div>
            </FadeIn>

            <FadeIn delay={0.1} data-id="element-224">
              <h1 className="text-4xl font-bold tracking-tight sm:text-6xl mb-6 leading-[1.1]" data-id="element-225">
                Recuperá tus noches: El método exacto para que tu gato deje de
                maullar a las 3 AM
                <span className="block text-gold mt-2 text-3xl sm:text-5xl italic font-normal" data-id="element-226">
                  (Sin remedios y sin estrés)
                </span>
              </h1>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-227">
              <p className="mt-6 text-lg leading-8 text-slate-400 font-sans" data-id="element-228">
                Dejá de ser un rehén de los caprichos nocturnos de tu mascota y
                volvé a dormir 8 horas de corrido en menos de 7 días.
              </p>
            </FadeIn>

            <FadeIn delay={0.3} className="mt-6 flex items-center gap-x-6" data-id="element-229">
              <Button onClick={() => document.getElementById('offer')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-230">
                ¡QUIERO VOLVER A DORMIR!
              </Button>
            </FadeIn>
          </div>

          <FadeIn delay={0.4} direction="left" className="mt-10 sm:mt-14 lg:mt-0 lg:flex-grow" data-id="element-231">
            <div className="relative mx-auto w-full max-w-lg lg:max-w-none" data-id="element-232">
              <div className="absolute -inset-x-4 -inset-y-4 z-0 bg-gradient-radial from-gold/20 to-transparent opacity-50 blur-2xl" data-id="element-233" />
              <img src="https://cdn.magicpatterns.com/uploads/3wNJ8cPmdAYXx6vMg6UdiJ/Mockup.png" alt="Gato Zen eBook Mockup" className="relative z-10 w-full rounded-2xl shadow-2xl ring-1 ring-white/10 box-glow" data-id="element-234" />
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}